import "./product-carousel-slider";

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.complementaryURL = this.dataset.url;
    this.wrapper = this.querySelector("[data-carousel-wrapper]");
  }

  connectedCallback() {
    if (this.complementaryURL) {
      this.fetchComplementary();
    }
  }

  fetchComplementary() {
    fetch(this.complementaryURL)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-carousel");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.style.display = "block";
          this.wrapper.style.display = "block";
        }
      })
      .catch((e) => {
        this.style.display = "none";
        console.error(e);
      });
  }
}

if (!customElements.get("product-carousel")) {
  customElements.define("product-carousel", ProductCarousel);
}
